/**
 * Poster URL heuristic for video files (aligned with beatly-web-app Carousel).
 */
export function getVideoPosterUrl(url: string): string | undefined {
  if (!url) return undefined;
  const [baseUrl, query] = url.split('?');
  const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.ogg', '.m4v'];
  const isVideo = videoExtensions.some((ext) => baseUrl.toLowerCase().includes(ext));
  if (!isVideo) return undefined;
  const posterBaseUrl = baseUrl.replace(/\.(mp4|mov|avi|webm|ogg|m4v)$/i, '.jpg');
  return query ? `${posterBaseUrl}?${query}` : posterBaseUrl;
}

export function isVideoFileUrl(url: string): boolean {
  if (!url) return false;
  const [baseUrl] = url.split('?');
  return /\.(mp4|mov|avi|webm|ogg|m4v|m3u8)$/i.test(baseUrl);
}
